import { IAidasUpload } from 'app/shared/model/ainnotateservice/aidas-upload.model';

export interface IAidasUploadMetaData {
  id?: number;
  name?: string | null;
  value?: string | null;
  aidasUpload?: IAidasUpload | null;
}

export const defaultValue: Readonly<IAidasUploadMetaData> = {};
